import { render } from "./IpAddressesTab.vue?vue&type=template&id=7ecbb41a&scoped=true"
import script from "./IpAddressesTab.vue?vue&type=script&lang=js"
export * from "./IpAddressesTab.vue?vue&type=script&lang=js"

import "./IpAddressesTab.vue?vue&type=style&index=0&id=7ecbb41a&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecbb41a"]])

export default __exports__